import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  DeleteDocumentsRequestTypes,
  DeleteDocumentsResponseTypes,
} from '../types';

export const deleteDocuments = (params: DeleteDocumentsRequestTypes) => {
  const { boardId, ...data } = params;

  const url = `/api/v2/boards/${boardId}/documents`;
  return apiAuthClient.delete<DeleteDocumentsResponseTypes>(url, {
    data,
  });
};
